export default {
    "/": {
        "title": "Taoify - منصة إنشاء مواقع التجارة الإلكترونية عبر الحدود | بضائع صينية، مبيعة عالمياً",
        "desc": "Taoify يجمع بناء الموقع والترجمة والإدراج والشحن والاستلام والتسويق في لوحة تحكم واحدة: 18 موظف ذكاء اصطناعي يعملون لك، متجر بأكثر من 20 لغة، بضائع صينية تباع حول العالم."
    },
    "/feature": {
        "title": "الخصائص · كل ما تحتاجه لفتح المتجر موجود على هذه الصفحة · Taoify",
        "desc": "إنشاء الموقع والترجمة والإدراج والشحن والاستلام وجذب العملاء – Taoify يضع 15 وحدة تحتاجها للبيع عبر الحدود في لوحة تحكم واحدة، فلا حاجة للبحث عن أدوات متعددة خارجياً."
    },
    "/ai-staff": {
        "title": "موظفو الذكاء الاصطناعي · 18 موظف ذكاء اصطناعي، الأكثر نشاطاً هم الذين يجلبون الزوار · Taoify",
        "desc": "من بين 18 موظف ذكاء اصطناعي، خمسة من فريق النمو مكرسين لحل مشكلة «عدم وجود زوار»: 12 فحصاً للمتجر، خطة تسويق لمدة 30 يوماً، إعادة كتابة منتج واحد إلى 9 قنوات جاهزة، رسائل البريد الإلكتروني التسويقية الآلية لإعادة العملاء السابقين."
    },
    "/logistics": {
        "title": "الشحن الدولي · من يدك إلى يد العميل · Taoify",
        "desc": "النقل الأول، وإتمام الإجراءات الجمركية، والشحن الرئيسي، والتوصيل النهائي، ثلاثة مسارات يتم اختيارها حسب البضاعة والتوقيت. تم ربط Yuntu, Yanwen, 4PX، حيث تكون البيانات والمتابعة ومعالجة الاستثناءات كلها في لوحة تحكم واحدة."
    },
    "/payment": {
        "title": "الدفع والاستلام · الدفع بطريقة تفضلها العملاء · Taoify",
        "desc": "PayPal, Stripe, بطاقات الائتمان, Alipay جاهزة للربط والاستخدام. استلام العملات الأجنبية، وسحب الريال الصيني، التسوية T+7، الرسوم وأوقات الوصول موضحة بشكل واضح."
    },
    "/pricing": {
        "title": "الأسعار · باقات الاشتراك + عمولة متدرجة · Taoify",
        "desc": "يتم فرض رسوم على المتاجر بناءً على باقات الاشتراك: النسخة الأساسية $15/شهر، النسخة القياسية $29/شهر، النسخة الفاخرة $59/شهر، توفير أكبر عند الاشتراك ربع سنوي أو سنوي. العمولة على المعاملات تتدرج حسب قيمة المبيعات الشهرية، وتبدأ من 3%."
    },
    "/cases": {
        "title": "قصص البائعين · هم يفعلون الشيء نفسه · Taoify",
        "desc": "الإكسسوارات من ييوو، الأجهزة الإلكترونية من شنتشن، الملابس من قوانغتشو، بالإضافة إلى الباعة من ألمانيا وأمريكا وفرنسا - ستة أشخاص، ستة بدايات، نفس الطريقة."
    },
    "/sign-up": {
        "title": "فتح المتجر - تسجيل مجاني في Taoify",
        "desc": "إنشاء متجرك الخاص بالعلامة التجارية في 10 دقائق بدون كتابة أي كود، تجربة جميع ميزات باقات الاشتراك. سجل الآن في Taoify وابدأ رحلتك في التجارة الإلكترونية عبر الحدود."
    },
    "/for-china-sellers": {
        "title": "للبائعين الصينيين · اختر المنتجات وحدّد الأسعار، نحن نهتم بالباقي · Taoify",
        "desc": "إنشاء المتجر، الترجمة، رسوم الشحن، طباعة الفواتير، الرد على العملاء - المنصة تقوم بكل هذه الأمور نيابة عنك. باقات اشتراك + عمولات متدرجة (تبدأ من 3%)."
    },
    "/for-global-sellers": {
        "title": "للبائعين الدوليين: اختر المنتجات من الرفوف الصينية واعرضها في متجرك الخاص · Taoify",
        "desc": "لا حاجة لتخزين البضائع أو الاحتفاظ بالمخزون: اختر المنتجات من سلسلة الإمداد الصينية وشحنها مباشرة من المستودعات الصينية بعد طلب العميل. BuyLink يمكنه تحويل الروابط من 1688 وتعobao إلى منتجاتك الخاصة."
    },
    "/template-index": {
        "title": "سوق القوالب - قوالب مواقع Taoify المهنية",
        "desc": "قوالب مواقع احترافية تناسب أي مشروع، استخدم العديد من القوالب المجانية حسب الصناعة، وتخصيص صورة العلامة التجارية والوظائف حسب الاحتياجات."
    },
    "/question": {
        "title": "مركز المساعدة · إذا كان لديك أي مشكلة، ابحث عنها هنا أولاً · Taoify",
        "desc": "فتح المتجر، التصميم، إدراج المنتجات، الشحن، الدفع، التسويق، صلاحيات الحساب - الأسئلة الشائعة مرتبة حسب الفئات، إذا لم تجد ما تبحث عنه يمكنك تقديم طلب دعم."
    },
    "/about-us": {
        "title": "حول Taoify · ما هي مهمتنا",
        "desc": "Taoify هو منصة بناء مواقع متكاملة للبائعين عبر الحدود: بناء الموقع، الترجمة، إدراج المنتجات، الشحن، الدفع، والتسويق كلها تتم من خلال لوحة تحكم واحدة."
    },
    "/privacy-policy": {
        "title": "سياسة الخصوصية · Taoify",
        "desc": "كيفية جمع و استخدام و تخزين و حماية معلوماتك الشخصية من قبل Taoify، بالإضافة إلى الحقوق التي تتمتع بها بشأن بياناتك."
    },
    "/terms-service": {
        "title": "شروط الخدمة · Taoify",
        "desc": "البنود والشروط لاستخدام خدمات منصة Taoify: الحسابات، المتاجر، الطلبات، الدفع وتوزيع المسؤوليات."
    },
    "/consumer-agreement": {
        "title": "سياسة الاسترداد · Taoify",
        "desc": "قواعد استرداد وخدمة ما بعد البيع لطلبات منصة Taoify: شروط التقديم، مدة المعالجة، وطرق التحويل."
    },
    "/user-agreement": {
        "title": "اتفاقية المستخدم · Taoify",
        "desc": "قبل التسجيل واستخدام Taoify، يرجى قراءة: شروط التسجيل، معايير إدارة المتجر، وتفاصيل خدمات المنصة."
    }
}
